"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CalcShiftOptions = void 0;
exports.calculateNumWorkerDiff = calculateNumWorkerDiff;
exports.calculateTransportCountDiff = calculateTransportCountDiff;
exports.calculateCellRoleCountDiff = calculateCellRoleCountDiff;
exports.calculateOffCountDiff = calculateOffCountDiff;
exports.calculateShiftOffCountDiff = calculateShiftOffCountDiff;
exports.calculateShiftRoleCountDiff = calculateShiftRoleCountDiff;
exports.calculateSectionRoleCountDiff = calculateSectionRoleCountDiff;
exports.calcLaborHours = calcLaborHours;
exports.calculateShiftLaborHoursDiff = calculateShiftLaborHoursDiff;
exports.calculateRestSectionTime = calculateRestSectionTime;
exports.calcShiftStats = calcShiftStats;
exports.calcSlotDiff = calcSlotDiff;
exports.calcCellStatsData = calcCellStatsData;
exports.calcCellDiff = calcCellDiff;
exports.calcRowStatsFromDiff = calcRowStatsFromDiff;
exports.calcColumnStatsFromDiff = calcColumnStatsFromDiff;
const common_1 = require("../js/common");
const models_1 = require("../js/models");
const stats_1 = require("../js/stats");
const offTypes_1 = __importDefault(require("./offTypes"));
const shiftCellStats_1 = require("./shiftCellStats");
const shiftColumnStats_1 = require("./shiftColumnStats");
const shiftRowStats_1 = require("./shiftRowStats");
const shiftStats_1 = require("./shiftStats");
const statsDiff_1 = require("./statsDiff");
const msPerHour = 3600000;
function calculateNumWorkerDiff(curIsNumWorkerEnabled, prevIsNumWorkerEnabled) {
    return countDiff(prevIsNumWorkerEnabled, curIsNumWorkerEnabled);
}
function calculateTransportCountDiff(curIsNumWorkerEnabled, prevIsNumWorkerEnabled) {
    return countDiff(prevIsNumWorkerEnabled, curIsNumWorkerEnabled);
}
//calculateCellRoleCountDiff adds the slot diff to its count and will return a diff for the row if the role count plus the diff has resulted in a zero or changed from a zero to a number greater than zero.
function calculateCellRoleCountDiff(isCellIncludedInRoleCountAfterDiff, isCellIncludedInRoleCountBeforeDiff) {
    //If the cell has added a new role or entirely removed a role, then we need to add the diff to the column role count
    return countDiff(isCellIncludedInRoleCountBeforeDiff, isCellIncludedInRoleCountAfterDiff);
}
function calculateOffCountDiff(isCellIncludedInOffCountNow, isCellIncludedInOffCountBefore) {
    return countDiff(isCellIncludedInOffCountBefore, isCellIncludedInOffCountNow);
}
function calculateShiftOffCountDiff(prev, current) {
    const diff = {};
    // Slot type 0 and 1 are workdays, so don't include them in off counts.
    if ((current > 1 || prev > 1) && current !== prev) {
        if (prev > 1) {
            diff[prev] = -1;
        }
        if (current > 1) {
            diff[current] = 1;
        }
    }
    return diff;
}
//calculateSlotRoleCountDiff will return an object with roleId to the difference in count.
function calculateShiftRoleCountDiff(prevRoleId, newRoleId) {
    const diff = {};
    if (prevRoleId !== newRoleId) {
        if (newRoleId) {
            diff[newRoleId] = 1;
        }
        if (prevRoleId) {
            diff[prevRoleId] = -1;
        }
    }
    ;
    return diff;
}
function calculateSectionRoleCountDiff(prevRoleIds, newRoleIds) {
    let diff = {};
    const allRoleIds = new Set([...prevRoleIds, ...newRoleIds]);
    allRoleIds.forEach(roleId => {
        const prevRoleId = prevRoleIds.includes(roleId) ? roleId : "";
        const newRoleId = newRoleIds.includes(roleId) ? roleId : "";
        diff = { ...calculateShiftRoleCountDiff(prevRoleId, newRoleId) };
    });
    return diff;
}
function calcLaborHours(i, periodStart, periodEnd) {
    let overlapMs = (0, common_1.overlapDuration)(i.getStartDate(), i.getEndDate(), periodStart, periodEnd);
    const overlapHours = overlapMs / msPerHour; // Milliseconds in an hour
    return overlapHours;
}
function calculateShiftLaborHoursDiff(prevLaborHours, curLaborHours) {
    return curLaborHours - prevLaborHours;
}
function calculateRestSectionTime(restSections, periodStart, periodEnd) {
    let hours = 0;
    restSections.forEach(section => {
        const restHours = calcLaborHours(section, periodStart, periodEnd);
        hours += restHours;
    });
    return hours;
}
function countDiff(prev, cur) {
    if (prev !== cur) {
        if (cur) {
            return 1;
        }
        else {
            return -1;
        }
    }
    return 0;
}
class CalcShiftOptions {
    ignoreRestSections = false;
    ignoreRestField = false;
    ignoreRole = false;
    ignoreTransport = false;
    ignoreLaborHours = false;
    hourlyWage = 0;
    ptoHours = 0;
    useSectionWage = false;
    constructor() { }
}
exports.CalcShiftOptions = CalcShiftOptions;
function calcShiftStats(shift, periodStart, periodEnd, options = new CalcShiftOptions()) {
    const stats = new shiftStats_1.ShiftStats();
    let isRestSection = false;
    for (let i = 0; i < shift.getSections().length; i++) {
        const section = shift.getSections()[i];
        const overlapMs = (0, common_1.overlapDuration)(periodStart, periodEnd, section.getStartDate(), section.getEndDate());
        if (section.getRoleId() && overlapMs) {
            stats.setRoleSectionId(section.getRoleId());
        }
        if (section.getType() <= 1) {
            continue;
        }
        const periodLength = periodEnd.valueOf() - periodStart.valueOf();
        if (overlapMs === periodLength) {
            isRestSection = true;
            break;
        }
    }
    // If the current shift has overlap. If not, then the previous version did and will adjust diff as if delete.
    const hasOverlap = (0, common_1.timespansOverlap)(periodStart, periodEnd, shift.getStartDate(), shift.getEndDate());
    const curIsNumWorkerEnabled = shift.getType() <= 1 && !isRestSection && hasOverlap;
    const countsInTransportCost = curIsNumWorkerEnabled && !options.ignoreTransport;
    const shouldCountLaborHours = shift.getType() <= 1 && !options.ignoreLaborHours;
    stats.setIsWorkerNumberCounted(curIsNumWorkerEnabled);
    let laborHours = 0;
    if (shouldCountLaborHours) {
        laborHours = calcLaborHours(shift, periodStart, periodEnd);
        // Prioritize Rest field
        let rest = shift.getRest();
        if (options.ignoreRestField) {
            rest = 0;
        }
        // Only calculate rest sections if Rest field is zero
        if (!options.ignoreRestSections && rest == 0) {
            const restSections = [];
            shift.getSections().map(s => {
                if (s.getType() == models_1.SLOT_TYPES.SECTION_REST) {
                    restSections.push(s);
                }
            });
            rest = calculateRestSectionTime(restSections, periodStart, periodEnd);
        }
        laborHours -= rest;
        if (laborHours < 0) {
            // Labor hours should never be less than zero.
            laborHours = 0;
        }
    }
    stats.setLaborHours(laborHours);
    if (hasOverlap && !options.ignoreRole) {
        stats.setRoleId(shift.getRoleId());
    }
    else {
        stats.setRoleId("");
    }
    stats.setTransportCost(countsInTransportCost);
    if (hasOverlap) {
        stats.setType(shift.getType());
    }
    else {
        stats.setType(-1);
    }
    let laborCost = 0;
    if (options.useSectionWage) {
        for (let i = 0; i < shift.getSections().length; i++) {
            const section = shift.getSections()[i];
            if (section.getType() === models_1.SLOT_TYPES.SECTION_REST) {
                continue;
            }
            const sectionDuration = calcLaborHours(section, periodStart, periodEnd);
            const sectionWage = section.getWage() || options.hourlyWage;
            laborCost += sectionWage * sectionDuration;
            laborHours -= sectionDuration;
        }
    }
    laborCost += (Math.max(laborHours, 0) + options.ptoHours) * options.hourlyWage;
    stats.setLaborCost(laborCost);
    return stats;
}
function calcSlotDiff(stats, prevStats = new shiftStats_1.ShiftStats()) {
    const statsDiffObject = new statsDiff_1.StatsDiff();
    statsDiffObject.numOfWorkers = calculateNumWorkerDiff(stats.isWorkerNumberCounted, prevStats.isWorkerNumberCounted);
    statsDiffObject.laborHours = calculateShiftLaborHoursDiff(prevStats.laborHours, stats.laborHours);
    statsDiffObject.roleCounts = calculateShiftRoleCountDiff(prevStats.getRoleId(), stats.getRoleId());
    statsDiffObject.laborCost = stats.laborCost - prevStats.laborCost;
    statsDiffObject.transportCost = calculateTransportCountDiff(stats.isCountedInTransportCost, prevStats.isCountedInTransportCost);
    statsDiffObject.offCounts = calculateShiftOffCountDiff(prevStats.type, stats.type);
    statsDiffObject.roleSectionCounts = calculateSectionRoleCountDiff(prevStats.getRolesectionIds(), stats.getRolesectionIds());
    return statsDiffObject;
}
function calcCellStatsData(slotStatsDiff, prevStats = new shiftCellStats_1.ShiftCellStats(), options) {
    const stats = new shiftCellStats_1.ShiftCellStats();
    const newNumOfWorkers = prevStats.numOfWorkers + slotStatsDiff.numOfWorkers;
    stats.setNumOfWorkers(newNumOfWorkers);
    const newLaborHours = prevStats.laborHours + slotStatsDiff.laborHours;
    stats.setLaborHours(newLaborHours);
    const laborCost = prevStats.laborCost + slotStatsDiff.laborCost;
    stats.setLaborCost(laborCost);
    const numOfTransports = prevStats.transportCostEnabledSlots + slotStatsDiff.transportCost;
    stats.setNumOfTransports(numOfTransports);
    const offCounts = { ...prevStats.offCounts };
    Object.keys(slotStatsDiff.offCounts).forEach(t => {
        const offType = parseInt(t);
        if (offCounts[offType]) {
            offCounts[offType] += slotStatsDiff.offCounts[offType];
        }
        else {
            offCounts[offType] = slotStatsDiff.offCounts[offType];
        }
    });
    stats.setOffCounts(offCounts);
    const roleCounts = { ...prevStats.roleCounts };
    const orRoleCounts = { ...prevStats.orRoleCounts };
    const roleSectionCounts = { ...prevStats.roleSectionCounts };
    Object.keys(slotStatsDiff.roleCounts).forEach(roleId => {
        if (roleCounts[roleId]) {
            roleCounts[roleId] += slotStatsDiff.roleCounts[roleId];
        }
        else {
            roleCounts[roleId] = slotStatsDiff.roleCounts[roleId];
        }
    });
    Object.keys(slotStatsDiff.roleSectionCounts).forEach(roleId => {
        if (roleSectionCounts[roleId]) {
            roleSectionCounts[roleId] += slotStatsDiff.roleSectionCounts[roleId];
        }
        else {
            roleSectionCounts[roleId] = slotStatsDiff.roleSectionCounts[roleId];
        }
    });
    if (options?.roles?.cur?.role && options.roles.cur.mainRoleId && slotStatsDiff.roleCounts[options.roles.cur.role.getId()]) {
        const mainRoleId = options.roles.cur.mainRoleId;
        const roleId = options.roles.cur.role.getId();
        if (orRoleCounts[mainRoleId]) {
            orRoleCounts[mainRoleId] += slotStatsDiff.roleCounts[roleId];
        }
        else {
            orRoleCounts[mainRoleId] = slotStatsDiff.roleCounts[roleId];
        }
    }
    if (options?.roles?.prev?.role && options.roles.prev.mainRoleId && slotStatsDiff.roleCounts[options.roles.prev.role.getId()]) {
        const mainRoleId = options.roles.prev.mainRoleId;
        const roleId = options.roles.prev.role.getId();
        if (orRoleCounts[mainRoleId]) {
            orRoleCounts[mainRoleId] += slotStatsDiff.roleCounts[roleId];
        }
        else {
            orRoleCounts[mainRoleId] = slotStatsDiff.roleCounts[roleId];
        }
    }
    stats.setRoleCounts(roleCounts);
    stats.setRoleSectionCounts(roleSectionCounts);
    stats.setOrRoleCounts(orRoleCounts);
    return stats;
}
function calcCellDiff(prevData, newData, transportCost) {
    const d = new statsDiff_1.StatsDiff();
    // num of workers
    d.numOfWorkers = calculateNumWorkerDiff(newData.numOfWorkers > 0, prevData.numOfWorkers > 0);
    // labor hours pass thru
    d.laborHours = newData.laborHours - prevData.laborHours;
    // role count
    Object.keys(prevData.roleCounts).forEach(roleId => {
        const id = parseInt(roleId);
        const cellDiff = calculateCellRoleCountDiff(newData.roleCounts[id] > 0, prevData.roleCounts[id] > 0);
        if (cellDiff) {
            d.roleCounts[id] = cellDiff;
        }
    });
    Object.keys(newData.roleCounts).forEach(roleId => {
        const id = parseInt(roleId);
        const cellDiff = calculateCellRoleCountDiff(newData.roleCounts[id] > 0, prevData.roleCounts[id] > 0);
        if (cellDiff) {
            d.roleCounts[id] = cellDiff;
        }
    });
    // role section count
    Object.keys(prevData.roleSectionCounts).forEach(roleId => {
        const id = parseInt(roleId);
        const cellDiff = calculateCellRoleCountDiff(newData.roleSectionCounts[id] > 0, prevData.roleSectionCounts[id] > 0);
        if (cellDiff) {
            d.roleSectionCounts[id] = cellDiff;
        }
    });
    Object.keys(newData.roleSectionCounts).forEach(roleId => {
        const id = parseInt(roleId);
        const cellDiff = calculateCellRoleCountDiff(newData.roleSectionCounts[id] > 0, prevData.roleSectionCounts[id] > 0);
        if (cellDiff) {
            d.roleSectionCounts[id] = cellDiff;
        }
    });
    Object.keys(prevData.orRoleCounts).forEach(roleId => {
        const cellDiff = calculateCellRoleCountDiff(newData.orRoleCounts[roleId] > 0, prevData.orRoleCounts[roleId] > 0);
        if (cellDiff) {
            d.orRoleCounts[roleId] = cellDiff;
        }
    });
    Object.keys(newData.orRoleCounts).forEach(roleId => {
        const cellDiff = calculateCellRoleCountDiff(newData.orRoleCounts[roleId] > 0, prevData.orRoleCounts[roleId] > 0);
        if (cellDiff) {
            d.orRoleCounts[roleId] = cellDiff;
        }
    });
    d.laborCost = newData.laborCost - prevData.laborCost;
    const countDiff = calculateTransportCountDiff(newData.transportCostEnabledSlots > 0, prevData.transportCostEnabledSlots > 0);
    if (countDiff) {
        if (countDiff == 1) {
            d.transportCost = transportCost;
        }
        else {
            d.transportCost = -transportCost;
        }
    }
    Object.keys(prevData.offCounts).forEach(o => {
        const type = parseInt(o);
        const diff = calculateOffCountDiff(newData.offCounts[type] > 0, prevData.offCounts[type] > 0);
        if (diff) {
            d.offCounts[type] = diff;
        }
    });
    Object.keys(newData.offCounts).forEach(o => {
        const type = parseInt(o);
        let diff = calculateOffCountDiff(newData.offCounts[type] > 0, prevData.offCounts[type] > 0);
        //Slot types 5, 102, and 103 are half PTO
        if ((0, stats_1.isHalfPTO)(type)) {
            diff *= 0.5;
        }
        if (diff) {
            d.offCounts[type] = diff;
        }
    });
    return d;
}
function calcRowStatsFromDiff(diff, prevStats) {
    const newStats = new shiftRowStats_1.ShiftRowStats();
    // labor hours
    const newLaborHours = prevStats.laborHours + diff.laborHours;
    newStats.setLaborHours(newLaborHours);
    // num of workers
    const newNumOfWorkers = prevStats.numOfWorkers + diff.numOfWorkers;
    newStats.setNumOfWorkers(newNumOfWorkers);
    // role counts
    const roleCounts = { ...prevStats.roleCounts };
    Object.keys(diff.roleCounts).forEach(roleId => {
        // setter!
        const newCount = diff.roleCounts[roleId] + (roleCounts[roleId] || 0);
        roleCounts[roleId] = newCount;
    });
    newStats.setRoleCounts(roleCounts);
    // or role counts
    const orRoleCounts = { ...prevStats.orRoleCounts };
    Object.keys(diff.orRoleCounts).forEach(id => {
        const newCount = diff.orRoleCounts[id] + (orRoleCounts[id] || 0);
        orRoleCounts[id] = newCount;
    });
    newStats.setOrRoleCounts(orRoleCounts);
    // off counts
    const offCounts = { ...prevStats.offCounts };
    Object.keys(diff.offCounts).forEach(t => {
        const type = parseInt(t);
        const offType = offTypes_1.default[type];
        const newCount = diff.offCounts[type] + (offCounts[offType] || 0);
        offCounts[offType] = newCount;
    });
    newStats.setOffCounts(offCounts);
    return newStats;
}
function calcColumnStatsFromDiff(diff, prevStats) {
    const newStats = new shiftColumnStats_1.ShiftColumnStats();
    const newNumOfWorkers = prevStats.numOfWorkers + diff.numOfWorkers;
    newStats.setNumWorkers(newNumOfWorkers);
    const newLaborHours = prevStats.laborHours + diff.laborHours;
    newStats.setLaborHours(newLaborHours);
    const roleCounts = { ...prevStats.roleCounts };
    const roleSectionCounts = { ...prevStats.roleSectionCounts };
    Object.keys(diff.roleCounts).forEach(roleId => {
        // setter!
        const newCount = diff.roleCounts[roleId] + (roleCounts[roleId] || 0);
        roleCounts[roleId] = newCount;
    });
    newStats.setRoleCounts(roleCounts);
    Object.keys(diff.roleSectionCounts).forEach(roleId => {
        const newCount = diff.roleSectionCounts[roleId] + (roleSectionCounts[roleId] || 0);
        roleSectionCounts[roleId] = newCount;
    });
    newStats.setRoleSectionCounts(roleSectionCounts);
    const orRoleCounts = { ...prevStats.orRoleCounts };
    Object.keys(diff.orRoleCounts).forEach(id => {
        const newCount = diff.orRoleCounts[id] + (orRoleCounts[id] || 0);
        orRoleCounts[id] = newCount;
    });
    newStats.setOrRoleCounts(orRoleCounts);
    newStats.laborCost = prevStats.laborCost + diff.laborCost;
    const transportCost = prevStats.transportCost + diff.transportCost;
    newStats.setTransportCost(transportCost);
    return newStats;
}
